import React from "react";
import { Box, Button } from "fw/components";
import { Form, MaskedBox, TextBox } from "fw/forms";
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Col, Row } from 'react-bootstrap';
import ErrorDialog from './ErrorDialog'
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';

class CertifyBusiness extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            loading: false,
            errorDialog: false,
            form: {
                vobFEIN: null,
                vobName: null
            }
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
    }

    updatePostData = (form) => {
        this.setState({ form });
    };

    handleCancel = () => {
        this.props.history.push('/');
    }

    handleCloseErrorDialog = () => {
        this.setState({ errorDialog: false });
    }

    errorDialog = () => {
        this.setState({
            errorDialog: true
        });
    }

    search = () => {
        if (!this.state.form.vobFEIN || !this.state.form.vobName)
            return;

        var rq = {
            vobFein: this.state.form.vobFEIN,
            vobName: this.state.form.vobName
        };

        API.Biz.get('/vobSetup/getExistingVob', rq, {
            success: (r) => {
                if (!r.data.vobExists)
                    this.props.history.push('/certification/addPreQualification/' +  r.data.vobFeinKey + '/' +  r.data.vobNameKey);
                else
                    this.errorDialog();
            },
            error: (r) => {
                Notifications.error(r.error.errorMessage);
            },
        });
    }

    render() {

        return (
            <React.Fragment>
                <ErrorDialog visible={this.state.errorDialog} onClose={this.handleCloseErrorDialog} />
                <Form
                    onChange={this.updatePostData}
                    values={this.state.form}
                    unsavedChangesWarning={true}>

                    <ContentHeader title="Certify Business">
                    </ContentHeader>
                    <ContentBody>
                        <Box>
                            <Row>
                                <Col md={12}>
                                    <h3>Please enter the Company's FEIN/EIN and Name – <small>VOCS needs to ensure this company does not already exist within the Database</small></h3>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} mdPush={4} style={{ textAlign: 'center' }}>
                                    <br />
                                    <MaskedBox value={this.state.form} name="vobFEIN" placeholder="Company FEIN/EIN" required mask="99-9999999" alwaysShowMask={false} maskChar="" ref={(c) => { this._vobFEIN = c }} />
                                    <br />
                                    <TextBox name="vobName" placeholder="Company Name" maxLength={128} required  ref={(c) => { this._vobName = c }} />
                                    <br />
                                    <Button
                                        id="search"
                                        bsStyle="primary"
                                        className="pull-right"
                                        onClick={this.search}>
                                        Search</Button>
                                    <Button
                                        id="cancel"
                                        bsStyle="default"
                                        className="pull-right"
                                        style={{ marginRight: 10 }}
                                        onClick={this.handleCancel}>Cancel</Button>
                                    <br />
                                    <br />
                                </Col>
                            </Row>
                        </Box>
                    </ContentBody>
                </Form>
            </React.Fragment >
        );
    }
}

export default CertifyBusiness;


// WEBPACK FOOTER //
// ./src/areas/companyManagement/certifyBusiness/CertifyBusiness.js